import kigyopro from '../../../images/logo/contest/kigyopro.png';
import nikkei_social_business from '../../../images/logo/contest/nikkei_social_business.jpg';
import seino from '../../../images/logo/contest/seino.jpg';
import jta from '../../../images/logo/contest/jta.jpg';

const contestList = [
  {
    imagePath: jta,
    alt: 'ジャパン・ツーリズム・アワード',
    name: '第六回「ジャパン・ツーリズム・アワード」受賞',
  },
  {
    imagePath: kigyopro,
    alt: '女性起業チャレンジコンテスト',
    name: '第五回「女性チャレンジ制度」グランプリ',
  },
  {
    imagePath: seino,
    alt: '地方創生ビジネスプランコンテスト',
    size: 'large',
    name: '第四回「地方創生ビジネスプランコンテスト」最優秀賞',
  },
  {
    imagePath: nikkei_social_business,
    alt: '日経ソーシャルビジネスコンテスト',
    name: '第二回「日経ソーシャルビジネスコンテスト」優秀賞',
  },
];

export default contestList;
